import type { ValuesType } from 'utility-types';

import type { CasinoPlayerGames, CasinoServiceParameters } from '@swf/cms';
import type { MarketingTag } from '@swf/core/types/CasinoGame';

export interface CasinoWidget {
  uid: string;
  game_service?: string;
  params?: CasinoServiceParameters;
  hide_on_login?: boolean;
  logged_in_only?: boolean;
}

export type CasinoIcon = NonNullable<ValuesType<CasinoServiceParameters['ims']['icon_tags']>>;
export type MosaicLayout = CasinoPlayerGames['mosaic_layout'];

export enum RenderNames {
  minBet = 'minBet',
  maxBet = 'maxBet',
  returnToPlayer = 'returnToPlayer',
  paylines = 'paylines',
  features = 'features'
}

export type FeatureVariant = 'standard' | 'no-bottom' | 'mini-detail' | 'persistent-info';

export type MarketingIcon = MarketingTag.New | MarketingTag.Exclusive;

export * from './races';
